/*
 * The --shop-* roles the storefront looks read beyond the Button ones (shopButton.ts): Swatch, Chip variants "shop" and
 * "shop-pill", IconButton variant="shop-float" and ThumbButton. Values live in products.shop.roles.dark; outside the
 * shop each role falls back to a base token or to no paint.
 */
export const SHOP_LOOK_ROLES = [
  'accent-bright',
  'swatch-shade',
  'swatch-rim',
  'swatch-mark-dark',
  'swatch-mark-light',
  'float-fill',
  'photo-card-hi',
  'photo-thumb-lo',
] as const;
export type ShopLookRole = (typeof SHOP_LOOK_ROLES)[number];

export const shopLookRole = (name: ShopLookRole, fallback: string): string => `var(--shop-${name}, ${fallback})`;

/* Photo gradient roles read by ThumbButton. The dropped U5 backdrop roles stay outside this inventory. */
export const SHOP_PHOTO_ROLES = [
  'photo-card-hi',
  'photo-thumb-lo',
] as const;
